<script setup>
import { onBeforeUnmount, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useAuthStore } from "../store/auth";
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import ArgonButton from "@/components/ArgonButton.vue";
import FullScreenLoader from "@/components/FullScreenLoader.vue";
import { loaderState, showLoader, hideLoader } from "../utils/loader/loader.js";
import { isPassword } from "../utils/validations/validationsInputs.js";
import imgHeader from "../assets/img/shapes/fondo-ontrix-horizontal.jpg";

const body = document.getElementsByTagName("body")[0];
const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();
const urlParams = ref("");
const headerIMG = ref(imgHeader);
const showPassword = ref(false);
const showPasswordTwo = ref(false);
const errors = ref({});
// Refs para las contraseñas
const password = ref("");
const confirmPassword = ref("");

// Validaciones
const validateField = (field) => {
  if (field === "password") {
    if (!password.value) {
      errors.value.password = "El campo contraseña es obligatorio.";
      return;
    }
    const result = isPassword(password.value);
    errors.value.password = typeof result === "string" ? result : null;
  }

  if (field === "confirmPassword") {
    if (!confirmPassword.value) {
      errors.value.confirmPassword =
        "El campo confirmar contraseña es obligatorio.";
      return;
    }
    const result = isPassword(confirmPassword.value);
    errors.value.confirmPassword = typeof result === "string" ? result : null;
  }
};

const validateForm = () => {
  validateField("password");
  validateField("confirmPassword");
  return Object.keys(errors.value).every((key) => !errors.value[key]);
};

const submitForm = async () => {
  // Validación para asegurar que las contraseñas coinciden
  if (!validateForm()) {
    return;
  }
  if (password.value !== confirmPassword.value) {
    toast.error("Las contraseñas no coinciden. Por favor, inténtalo de nuevo.");
    return;
  }

  showLoader();

  const data = {
    token: urlParams.value.get("token"),
    password: password.value,
  };
  // Aquí puedes realizar una llamada al método de autenticación con la contraseña
  const response = passChange()
    ? await authStore.resetPassword(data)
    : await authStore.crearPassword(data);
  if (response.ok) {
    toast.success("Contraseña actualizada exitosamente.");
    router.push("/");
  } else {
    toast.error(response.message || "Error al actualizar la contraseña.");
  }

  hideLoader();
};

const passChange = () => {
  if (route.path === "/reset-password") {
    return true;
  } else {
    return false;
  }
};

const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

onMounted(async () => {
  passChange();
  urlParams.value = new URLSearchParams(window.location.search);
  const resultToken = await authStore.pingtoken(urlParams.value.get("token"));
  if (resultToken.ok) {
    toast.success("Favor de colocar tu contraseña");
  } else {
    toast.error(resultToken.message);
    router.push('/');
  }
});
const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value;
};
const togglePasswordVisibilityTwo = () => {
  showPasswordTwo.value = !showPasswordTwo.value;
};
</script>

<template>
  <main class="main-content mt-0">
    <div
      class="page-header align-items-start min-vh-50 pt-5 pb-11 m-3 border-radius-lg"
      style="background-position: top"
      :style="{
        backgroundImage: `url(${headerIMG})`,
      }"
    >
      <!-- <span class="mask bg-gradient-dark opacity-6"></span> -->
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 text-center mx-auto">
            <h1 class="text-white mb-2 mt-5">¡Bienvenido!</h1>
            <p class="text-lead text-white" v-if="!passChange()">
              
            </p>
            <p class="text-lead text-white" v-if="passChange()">
              Por favor, ingresa tu nueva contraseña y confírmala para
              continuar.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
        <div class="col-xs-10 col-md-10 col-lg-4">
          <div class="card z-index-0">
            <div class="card-header text-center pt-4">
              <h5>Crea tu contraseña para continuar.</h5>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <label for="password" class="form-label"
                  >Crear Contraseña</label
                >
                <input
                  id="password"
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control"
                  v-model="password"
                  placeholder="Ingresa tu contraseña"
                  maxlength="8"
                />
                <button
                  type="button"
                  class="btn-password-view"
                  @click="togglePasswordVisibility"
                >
                  <i
                    :class="!showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                  ></i>
                </button>
                <div v-if="errors.password" class="text-danger text-sm">
                  {{ errors.password }}
                </div>
              </div>
              <div class="mb-3">
                <label for="confirm-password" class="form-label"
                  >Confirma tu Contraseña</label
                >
                <input
                  id="confirm-password"
                  :type="showPasswordTwo ? 'text' : 'password'"
                  class="form-control"
                  v-model="confirmPassword"
                  placeholder="Confirma tu contraseña"
                  maxlength="8"
                />
                <button
                  type="button"
                  class="btn-password-view"
                  @click="togglePasswordVisibilityTwo"
                >
                  <i
                    :class="
                      !showPasswordTwo ? 'fas fa-eye-slash' : 'fas fa-eye'
                    "
                  ></i>
                </button>
                <div v-if="errors.confirmPassword" class="text-danger text-sm">
                  {{ errors.confirmPassword }}
                </div>
              </div>
              <div class="text-center mt-4">
                <argon-button
                  fullWidth
                  class="my-4 mb-2"
                  @click="submitForm"
                >
                  Continuar
                </argon-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <full-screen-loader :isVisible="loaderState.isVisible" />
  </main>
</template>
<style scoped>
.posi-relative {
  position: relative;
}

.btn-password-view {
  position: absolute;
  /* top: 50%; */
  right: 25px;
  transform: translateY(-114%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  color: #6c757d;
}

.btn-password-view:hover {
  color: #000; /* Cambia el color al pasar el mouse */
}
</style>
